import { render, staticRenderFns } from "./RecadoComposeDialog.vue?vue&type=template&id=b208d7ee&scoped=true"
import script from "./RecadoComposeDialog.vue?vue&type=script&lang=js"
export * from "./RecadoComposeDialog.vue?vue&type=script&lang=js"
import style0 from "./RecadoComposeDialog.vue?vue&type=style&index=0&id=b208d7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b208d7ee",
  null
  
)

export default component.exports